import { Section, Chapter, Reveal } from "./Section";
import LeadForm from "./LeadForm";

const AUDIENCES = ["Young Men", "Emerging Leaders", "Ministry Leaders", "Entrepreneurs", "Purpose Seekers"];

export default function Coaching() {
  return (
    <Section id="coaching" testid="coaching-section">
      <div className="grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-6">
          <Chapter number="07" label="Coaching & Mentorship" testid="coaching-chapter"
            title={<>Discover Your Purpose.<br /><span className="text-vg">Develop Your Potential.</span></>}
            sub="Beyond the pulpit — life coach, motivational speaker, inspirational mentor, and leadership developer. Helping people move from potential to intentional progress." />
          <Reveal delay={0.2} className="mt-8">
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal max-w-lg">
              Focused on those seeking greater clarity, direction, discipline, and purpose — one-on-one coaching
              and mentorship shaped by four decades of ministry and leadership experience.
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {AUDIENCES.map((a) => (
                <span key={a} data-testid={`coaching-audience-${a.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="glass px-3.5 py-2 rounded-full text-slate-200 font-mono text-xs uppercase tracking-[0.2em] hover:border-violet-400/50 hover:text-white transition-colors duration-300">
                  {a}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-6 glow-frame">
          <div className="rounded-[1.7rem] bg-[#0B0E16] p-7 sm:p-9">
            <p className="mb-6 font-mono text-sm font-semibold uppercase tracking-[0.25em] text-vg">Book a Coaching Session</p>
            <LeadForm type="coaching" idPrefix="coaching" extra={["phone", "message"]} submitLabel="Book a Coaching Session" />
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
